import { SYSAction } from "../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import { TableRefresh } from "../../../../../../../_ovlclient/src/library/table/tableapi"

const HookSYSLoginSuccess: SYSAction = async (value, { global }) => {
  let state = global.getState()
  state.ovl.user.isSuperUser =
    state.ovl.user.isActor || state.ovl.user.role === "Admin"
  let userState = state.app.global.GEN.user
  let offeringGlobalState = state.app.global.QUT.offering
  let res = await Data("initial/initial")
  if (res.data) {
    userState.offeringCadAttr = res.data.offeringCadAttr
    userState.offeringCadVal = res.data.offeringCadVal
    userState.offeringCadUserField = res.data.offeringCadUserField
    userState.offeringDummyMaterialItemCode =
      res.data.offeringDummyMaterialItemCode
    offeringGlobalState.offeringInitialCutSize = res.data.offeringInitialCutSize
    offeringGlobalState.offeringSawCutSize = res.data.offeringSawCutSize
  }

  // initialize offering usersettings already here
  let d = {
    CntctCode: state.ovl.user.userCode,
    U_PrtOfferingCadAttr: userState.offeringCadAttr,
    PrtOfferingCadUserField: userState.offeringCadUserField,
    U_PrtOfferingCadVal: userState.offeringCadVal,
  }
  let userdata: Array<any> = [d]
  // refresh the data with localdata. needs to be done once if there are more settings def
  await TableRefresh("QUTOfferingSettings", {
    localData: userdata,
    suppressBusySnack: true,
  })
  await global.getActions().app.global.actions.HandleDataRefresh()
}
export let hooks = { HookSYSLoginSuccess }
